export { default as PartnerCardsSection } from './PartnerCards';
export { partnerCardsDiverseAdapter } from './adapters';
